import React, { useState, useEffect } from "react";
import Header from "../../Components/Header";
import SubHeader from "../../Components/SubHeader";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { styled } from "@mui/system";
import { getUserId } from "../../utlis/tokenUtils";
import apiClient from "../../utlis/apiClient";
import { Backdrop, CircularProgress } from "@mui/material";

const StyledTextField = styled(TextField)({
  "& .MuiInputBase-input::placeholder": {
    fontSize: "10px", // Adjust this to change only the placeholder size
  },
});

const AddCustomer = () => {
  const currentDate = new Date().toLocaleDateString("en-GB");
  const [phoneError, setPhoneError] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    CustomerEmail: "",
    GSTNumber: "",
    Address: "",
    PhoneNumber: "",
    Comments: "", 
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    if (name === "PhoneNumber") {
      if (value.length !== 10) {
        setPhoneError("Phone number must be exactly 10 digits");
      } else {
        setPhoneError(""); // Clear error if valid
      }
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setLoading(true); // Start loading
    try {
      const response = await apiClient.post(
        `/api/customer/create-customer`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data, ": the customer insert");

      // Check for a successful response
      if (response.data.result && response.data.result.success) {
        console.log(
          "Customer created successfully:",
          response.data.result.message
        );
        alert("Customer inserted successfully");

        // Reset the form to its initial state
        setFormData({
            Name: "",
            CustomerEmail: "",
            GSTNumber: "",
            Address: "",
            PhoneNumber: "",
            Comments: "", 
        });

        window.location.reload();
        
      } else {
        console.error(
          "Error creating Customer:",
          response.data.result.message || "Unknown error"
        );
        alert("Unable to insert the Customer");
      }
    } catch (error) {
      console.error("Network error:", error);
      alert("There was a network error, please try again.");
    } finally {
      setLoading(false); // End loading
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Header />
      <SubHeader />

      <Grid
        container
        sx={{ flexGrow: 1, marginTop: "-80px", padding: 0 }}
        spacing={6}
      >
        <Grid item xs={12} md={2}>
          <Box
            sx={{
              height: "calc(100vh - 112px)",
              backgroundColor: "white",
              borderRadius: "10px",
              marginLeft: "15px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          ></Box>
        </Grid>

        <Grid item xs={12} md={9}>
          <Box
            sx={{
              height: "calc(100vh - 112px)",
              backgroundColor: "white",
              padding: 2,
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              marginLeft: "-60px",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Customer Details
            </Typography>
            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={2}>
                  <TextField
                    id="Name"
                    name="Name"
                    label="Customer Name"
                    variant="standard"
                    type="text"
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    id="CustomerEmail"
                    name="CustomerEmail"
                    label="Customer Email"
                    type="email"
                    onChange={handleChange}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    id="GSTNumber"
                    name="GSTNumber"
                    label="GST Number"
                    type="text"
                    onChange={handleChange}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    id="Address"
                    name="Address"
                    label="Address"
                    variant="standard"
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    id="PhoneNumber"
                    name="PhoneNumber"
                    label="Phone Number"
                    type="tel"
                    variant="standard"
                    value={formData.PhoneNumber}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={!!phoneError} // Highlights input in red if there's an error
                    helperText={phoneError} // Shows the error message below the field
                  />
                </Grid>


                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Comments"
                    name="Comments"
                    variant="outlined"
                    value={formData.Comments}
                    onChange={handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    multiline
                    rows={2}
                  />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Grid>
      </Grid>
      <Backdrop
        open={loading}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: "#fff" }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default AddCustomer;